import { backendApi } from "./backendApi.rtkq";

// Types for summary data
export interface SummaryResult {
  text: string;
  title: string;
  tags: string[];
  usage: {
    inputTokens: number;
    outputTokens: number;
    totalTokens: number;
  };
  parameters: {
    model: string;
  };
  processingTime: number;
}

export interface SummaryRequest {
  transcriptionId: string;
  userId: string;
  participants?: string[];
  questions?: string[];
  answers?: string[];
  additionalContext?: string;
}

// Parameters for queries
export interface GetSummaryParams {
  userId: string;
  transcriptionId: string;
}

export const summariesApi = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    // Generate summary mutation
    generateSummary: builder.mutation<SummaryResult, SummaryRequest>({
      query: ({ transcriptionId, ...rest }) => ({
        url: `/transcriptions/${transcriptionId}/summary`,
        method: "POST",
        body: rest,
      }),
      transformResponse: (response: any) => {
        // Backend may wrap in { success, data } or return directly
        return response.data || response;
      },
      invalidatesTags: (_result, _error, { userId }) => [
        { type: "Transcriptions", id: `user-${userId}` },
      ],
    }),
  }),
});

export const {
  useGenerateSummaryMutation,
} = summariesApi;
